<style scoped lang="less">
@import "../../../static/less/common";
.card-img{
    padding-top: 30%;
    text-align: center;
    img{
        width: 28vh;
    }
    .card-text{
        font-size: medium;
        font-weight: bolder;
    }
}
.close{
    padding: 3vh 3vh;
    text-align: right;
    img{
        width: 3.5vh;
    }
}
</style>

<template>
    <div class="backBox">
        <div class="close">
            <img src="../../assets/network-card/close.png" @click="closePage">
        </div>
        <div class="card-img">
            <img src="../../assets/network-card/notBL.png">
            <div class="card-text">
                您尚未办理网证
            </div>
        </div>
        <div class="fixBottom">
            <van-button round color="#286EFF" class="next-btn" @click="toDeal">去开通</van-button>
        </div>
    </div>
</template>

<script>
import { Button } from "vant";
import { showGoBackBtn,goToClose ,closeWindow} from "@/util/jsbridge"
export default {
    name: "NoCard",
    components:{
        [Button.name]:Button,
    },
    data(){
        return{
            lists:[]
        }
    },
    created(){
        window.toDeal= this.toDeal;
        showGoBackBtn([{title:'去开通', duration:0, bgColor:'#518afd', methodName:'toDeal', methodParameter:''}]);
    },
    methods:{
        toDeal(){
            goToClose("https://app.robooot.com/auth/IndentityFirstActivity",'SYVIEIDNewIntroduceVC','','IndentityFirstActivity')
        },
        closePage(){
            closeWindow();
        }
    }
}
</script>
